export default {
  sidebar: {
    personalAccount: "Жеке кабинет",
    menu: "мәзір",
    home: "Басты бет",
    services: "Қызметтер",
    myRequests: "Менің өтінімдерім",
    callHistory: "Менің қоңырауларым",
    osintSearch: "Time to search",
    help: "Көмек",
    logout: "Шығу",
    logoutConfirmTitle: "Растау",
    logoutConfirmMessage: "Шығуға сенімдісіз бе?",
    logoutConfirmYes: "Иә",
    logoutConfirmNo: "Жоқ",
    helpNotAvailable: "Көмек бөлімі жақында қолжетімді болады",
    language: "Тіл",
    theme: "Тақырып",
    lightTheme: "Жарық",
    darkTheme: "Қараңғы",
    darkThemeLabel: "Қараңғы",
    lightThemeLabel: "Жарық",
    call: "Байланыс",
    callOperator: "Оператормен байланыс",
    videoCall: "Бейне",
    audioCall: "Аудио",
    textChat: "Мәтін",
  },
  login: {
    clientPortal: "Клиенттік портал",
    greeting: "Клиенттік портал",
    description:
      "Қызметтерді басқарыңыз, өтінімдерді қадағалаңыз және мәртебелерді бір интерфейсте бақылаңыз.",
    descriptionTagline: "Жылдам. Түсінікті. Іс жүзінде.",
    copyright: "© {year} Клиенттік портал. Барлық құқықтар қорғалған.",
    welcomeTitle: "Қош келдіңіз",
    welcomeSubtitle: "клиенттік порталға",
    registerTitle: "Тіркелгі жасау",
    verifyTitle: "Email растау",
    noAccount: "Тіркелгі жоқ па?",
    createAccount: "Тіркелу",
    hasAccount: "Тіркелгіңіз бар ма?",
    loginLink: "Кіру",
    noAccess: "Рұқсат жоқ па?",
    contactAdmin: "Әкімшіге хабарласыңыз",
    emailPlaceholder: "Email",
    passwordPlaceholder: "Құпиясөз",
    firstNamePlaceholder: "Аты",
    lastNamePlaceholder: "Тегі",
    otpPlaceholder: "Хаттан код",
    otpHint: "Email-ге жіберілген 6 санды кодты енгізіңіз",
    loginButton: "Кіру",
    registerButton: "Тіркелу",
    verifyButton: "Растау",
    backToLogin: "Кіруге оралу",
    loginWithGoogle: "Google арқылы кіру",
    loginWithApple: "Apple арқылы кіру",
    forgotPassword: "Құпиясөзді ұмыттыңыз ба?",
    emailError: "Пайдаланушы email алу мүмкін болмады",
    invalidEmail: "Жарамды email енгізіңіз",
    tempLoginSuccess: "Уақытша кіру орындалды",
    authError: "Аутентификация қатесі",
    emailNotVerified: "Email расталмаған. Хаттан кодты енгізіңіз",
    emailAlreadyExists: "Бұл email тіркелген",
    registerError: "Тіркелу қатесі",
    otpSent: "Растау коды email-ге жіберілді",
    otpInvalid: "Жарамсыз немесе мерзімі өткен код",
    oauthError: "Сыртқы қызмет арқылы аутентификация қатесі",
    googleError: "Google арқылы кіру қатесі",
    appleError: "Apple арқылы кіру қатесі",
    forgotTitle: "Құпиясөзді қалпына келтіру",
    forgotPrompt: "Код алу үшін email енгізіңіз",
    forgotButton: "Кодты жіберу",
    resetPasswordTitle: "Жаңа құпиясөз орнату",
    resetPasswordPrompt: "Хаттан кодты және жаңа құпиясөзді енгізіңіз",
    resetPasswordButton: "Сақтау",
    confirmPasswordPlaceholder: "Құпиясөзді қайталаңыз",
    passwordMin6: "Кемінде 6 таңба",
    passwordMismatch: "Құпиясөздер сәйкес келмейді",
    resendCode: "Кодты қайта жіберу",
    codeResent: "Код email-ге жіберілді",
    passwordResetSuccess: "Құпиясөз жаңартылды, қайта кіріңіз",
    resetCodeInvalid: "Жарамсыз немесе мерзімі өткен код",
  },
  validation: {
    fieldRequired: "Өріс бос болмауы керек",
    invalidCredentials: "Қате логин немесе құпиясөз",
    networkError:
      "Желі мәселесі. Қосылымды тексеріңіз немесе кейінірек қайталаңыз.",
  },
  chat: {
    howCanIHelp: "Сізге қалай көмектесе аламын?",
    interestedInService: "Қызметке қызығушылық: {service}",
    detectingIntent: "Сәйкес қызметтерді іздеу...",
    foundForms: "{count} қызмет табылды. Қажеттісін таңдаңыз:",
    noFormFound:
      "Сәйкес қызмет табылмады. Тапсырманы толығырақ сипаттап көріңіз.",
    noFormsAvailable: "Жүйеде қазір қолжетімді қызметтер жоқ.",
    intentError: "Сервис уақытша қолжетімсіз. Кейінірек қайталаңыз.",
  },
  services: {
    title: "Қызметтер",
    newRequest: "Жаңа өтінім",
    emptyList: "Қызметтер тізімі бос",
    fields: "{count} өріс",
    otherServices: "Басқа қызметтер",
    cancel: "Бас тарту",
    submit: "Жіберу",
    fillField: "Өрісті толтырыңыз: {field}",
    requestSent: "Өтінім жіберілді",
    active: "Белсенді",
    inactive: "Белсенді емес",
    stages: {
      initiation: "Өтінімді бастау",
      initiationSub: "Қызметті, орынды, паспорт түрін таңдау.",
      preliminaryCheck: "Алдын ала тексеру",
      preliminaryCheckSub: "Толықтығын/жарамдылығын/төлемін тексеру.",
      verification: "Жеке басын растау",
      verificationSub: "Деректер базасымен салыстыру, нақтылау.",
      closing: "Істі жабу",
      closingSub: "Қайтару/нәтижені растау.",
    },
    visa: {
      stepPurpose: "Мақсат",
      stepPurposeDesc: "Сапар мақсаты мен күндері",
      stepPersonal: "Жеке деректер",
      stepPersonalDesc: "ФИО, байланыс, азаматтық",
      stepPassport: "Паспорт",
      stepPassportDesc: "Нөмірі және мерзімі",
      stepTravel: "Болу",
      stepTravelDesc: "Ұйым және мекенжай",
      stepDocuments: "Құжаттар",
      stepDocumentsDesc: "Фото, скан, шақыру",
      stepReview: "Тексеру",
      stepReviewDesc: "Жіберу алдында тексеру",
      purposeTitle: "Сапардың мақсаты",
      purposeDesc:
        "Сапарыңыздың мақсатын және жоспарланған күндерді көрсетіңіз.",
      personalTitle: "Өтініш берушінің деректері",
      personalDesc:
        "Жеке деректеріңізді толтырыңыз. * белгіленген өрістер міндетті.",
      passportTitle: "Паспорт деректері",
      passportDesc: "Паспорт нөмірін және жарамдылық мерзімін енгізіңіз.",
      travelTitle: "Болу деректері",
      travelDesc: "Қабылдаушы ұйымды және елде болу мекенжайын көрсетіңіз.",
      documentsTitle: "Фото және құжаттар",
      documentsDesc:
        "Фотосуретті, паспорт сканін және шақыру хатын жүктеңіз (бар болса).",
      photoRequirements: "Фотоға қойылатын талаптар",
      photoRule1: "Өлшемі: 35 x 45 мм",
      photoRule2: "Ашық фондағы түрлі-түсті фото",
      photoRule3: "Бет кадрдың 70-80% алуы керек",
      photoRule4: "Бас киімсіз (діни бас киімнен басқа)",
      photoRule5: "Күңгірт көзілдіріксіз",
      photoRule6: "Формат: JPEG немесе PNG, 5 МБ дейін",
      uploadFile: "Файл жүктеу",
      uploadError: "Файл жүктеу қатесі",
      fileAttached: "Файл тіркелді",
      reviewTitle: "Деректерді тексеру",
      reviewDesc: "Жіберу алдында барлық деректерді тексеріңіз.",
      back: "Артқа",
      next: "Келесі",
    },
  },
  requests: {
    title: "Менің өтінімдерім",
    newRequest: "Жаңа өтінім",
    emptyList: "Әзірше өтінімдер жоқ",
    stage: "Кезең: {stage}",
    defaultStage: "Өтінімді толтыру",
    noDescription: "Сипаттамасыз",
    details: "Толығырақ",
    detailsTitle: "Өтінім мәліметтері",
    service: "Қызмет:",
    status: "Мәртебе:",
    currentStage: "Ағымдағы кезең:",
    summary: "Қысқаша:",
    description: "Сипаттама:",
    stageDataEmpty: "Кезең деректері әлі толтырылмаған",
    cancel: "Бас тарту",
    submitToCrm: "CRM-ге жіберу",
    servicesEmpty: "Қызметтер тізімі бос",
    statusLabels: {
      new: "Жаңа",
      in_progress: "Жұмыста",
      completed: "Аяқталды",
      rejected: "Қабылданбады",
    },
    stageLabels: {
      fill: "Өтінімді толтыру",
      check: "Деректерді тексеру",
      process: "Жұмыста",
      done: "Аяқтау",
    },
    stageStates: {
      done: "Аяқталды",
      active: "Ағымдағы",
      pending: "Күтуде",
    },
    analytics: {
      new: "Жаңа",
      inProgress: "Жұмыста",
      completed: "Аяқталған",
      rejected: "Қабылданбаған",
      resolutionSpeed: "Шешу жылдамдығы",
      avgTime: "Орташа уақыт",
      fastest: "Ең жылдам",
      lastActivity: "Соңғы белсенділік",
      lastResponse: "Соңғы жауап",
      lastRequest: "Соңғы өтінім",
      byService: "Қызметтер бойынша",
      noService: "Қызметсіз",
      days: "{n} күн",
      hours: "{n} сағат",
    },
    tableColumns: {
      id: "ID",
      service: "Қызмет",
      status: "Мәртебе",
      created: "Құрылған",
      actions: "Әрекеттер",
    },
  },
  callHistory: {
    title: "Менің қоңырауларым",
    emptyList: "Қоңыраулар тарихы жоқ",
    caller: "Нөмір",
    media: "Байланыс түрі",
    statusLabel: "Мәртебе",
    duration: "Ұзақтығы",
    date: "Күні",
    rating: "Баға",
    detailsTitle: "Қоңырау мәліметтері",
    case: "Нәтиже",
    queue: "Кезек",
    startTime: "Басталуы",
    endTime: "Аяқталуы",
    talkTime: "Сөйлесу",
    waitTime: "Күту",
    totalTime: "Жалпы уақыт",
    feedback: "Кері байланыс",
    comment: "Пікір",
    operators: "Операторлар",
    recall: "Қайта қоңырау шалу",
    recallHint:
      "Осы операторға сол байланыс түрімен тікелей жаңа қоңырау бастау",
    sec: "сек",
    min: "мин",
    mediaTypes: {
      voice: "Дауыс",
      audio: "Аудио",
      video: "Бейне",
      text: "Мәтін",
    },
    analytics: {
      answered: "Жауап берілді",
      missed: "Жіберілді",
      other: "Басқа",
      metrics: "Көрсеткіштер",
      totalCalls: "Барлық қоңыраулар",
      avgTalkTime: "Орт. сөйлесу уақыты",
      avgWaitTime: "Орт. күту уақыты",
      byMedia: "Байланыс түрі бойынша",
    },
  },
  chatForm: {
    fileUploaded: "Файл сәтті жүктелді",
    fileUploadedHint: "Енді құжат мазмұны туралы кез келген сұрақ қоя аласыз",
    placeholder: "Мәселеңізді немесе қандай қызмет алғыңыз келетінін жазыңыз",
    tooLong: "Сұрауыңыз тым ұзын. Қысқартыңыз. Максималды токен саны: {limit}",
    maxTokens: "Максималды токен саны: {limit}",
    maxFiles: "Ең көбі {limit} файл жүктеуге болады",
    maxFileSize: "Файл {size} аспауы керек",
    attachedFiles: "Тіркелген файлдар: {count}",
  },
  stt: {
    init: "Микрофонға қол жеткізу ...",
    started: "Жазу басталды (аяқтау үшін Тоқтатуды басыңыз)",
    micError: "Микрофонға қол жеткізу қатесі",
    uploading: "Аудио жүктелуде ...",
    uploadError: "Аудио жүктеу қатесі",
    finished: "Аудио жүктеу аяқталды",
  },
  search: {
    placeholder: "Іздеу және сүзгі",
    resetFilters: "Сүзгілерді қалпына келтіру",
    appliedFilters: "Қолданылған сүзгілер: {count}",
  },
  audio: {
    pause: "Кідірту",
    listen: "Тыңдау",
  },
  message: {
    you: "Сіз",
    copy: "Көшіру",
  },
};
